import { Component, OnInit } from '@angular/core';
import { FAQ } from 'src/app/_models/FAQ.model';
import { ToastrService } from 'ngx-toastr';
import { baseUrl, environment } from 'src/environments/environment';
import { showNotification } from 'src/app/helpers/show-toast';
import { FAQService } from 'src/app/_services/faq.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { DeleteModalComponent } from '@components/delete-modal/delete-modal.component';

@Component({
  selector: 'app-faq-list',
  templateUrl: './faq-list.component.html',
  styleUrls: ['./faq-list.component.scss']
})
export class FaqListComponent implements OnInit {
  pageTitle: string = 'FAQs';
  placeholder: string = 'Search by FAQ name …';
  FAQsArray: FAQ[] = [];
  filteredFAQsArray: FAQ[] = [];

  modalRef: BsModalRef;

  constructor(
    private faqServise: FAQService,
    public toastr: ToastrService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.getAllFAQs();
  }

  getAllFAQs() {
    this.faqServise.getAllFAQ().subscribe((res) => {
      res?.data?.adminFAQs.map((faq) => {
        this.FAQsArray.push(faq);
      });

      this.filteredFAQsArray = [...this.FAQsArray];
    });
  }


  onDeleteFAQ(event, item): void {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-danger',
      initialState: {
        itemId: item.id,
        itemName: item.question,
      },
    };

    this.modalRef = this.modalService.show(DeleteModalComponent, initialState);

    this.modalRef.content.event.subscribe((data) => {
      this.onDeleteFAQSubmit(item.type, data);
    });
  }

  onDeleteFAQSubmit(faqType, faqId) {
    this.faqServise.deleteFAQ(faqId).subscribe((res) => {
      showNotification(
        'success',
        `FAQ has been deleted`,
        this.toastr
      );

      this.FAQsArray = this.FAQsArray.filter(
        (doctor) => doctor.id !== faqId
      );

      this.filteredFAQsArray = [...this.FAQsArray];

      this.modalRef.hide();
    });
  }
}

